import React from "react";
import "../styles/DestinationGallery.css";

const places = [
  { name:"Rishikesh", img:"https://images.unsplash.com/photo-1501785888041-af3ef285b470" },
  { name:"Kasol", img:"https://images.unsplash.com/photo-1500530855697-b586d89ba3ee" },
  { name:"Manali", img:"https://images.unsplash.com/photo-1507525428034-b723cf961d3e" },
  { name:"Bir Billing", img:"https://images.unsplash.com/photo-1493244040629-496f6d136cc3" }
];

export default function DestinationGallery(){
  return(
    <section className="destinations">

      <h2>Explore Himalayan Destinations</h2>

      <div className="destination-grid">

        {places.map((place,i)=>(
          <div className="destination-card" key={i}>
            <img src={place.img} alt={place.name}/>
            <h3>{place.name}</h3>
          </div>
        ))}

      </div>

    </section>
  )
}